import React, { Component } from "react";
import { Modal, Descriptions, Input } from "antd";
import { render } from "less"; 
import { httpUrl, httpPost } from "../../api/httpClient";
import {formatDate } from "../../util";
const Ditems = Descriptions.Item;

class InquiryDetailModal extends Component {
    state = {
        answer: this.props.data.answer
    }




onCancel = () => {
    this.props.onCancel();
};

componentDidMount() {}

render() {
  const { visible, data, onClose } = this.props;
  return (
    <Modal
        visible={visible}
        title={"상세보기"}
        onOk={()=>{
            httpPost(httpUrl.inquiryCreate, [], {
                idx:data.idx, answer:this.state.answer,
            }).then((res) =>{
                if(res.data === "SUCCESS"){
                    alert("답변이 등록되었습니다.")
                    onClose()
                } else {
                    alert("등록에 실패하였습니다.")
                }
            })
        }}
        onCancel={onClose}        
        okText={"등록"}
        cancelText="취소"  
        style={{ minWidth: "800px"}}
    >
        <Descriptions
            bordered
            column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}
        >            
            <Ditems label="작성자" span={1} labelStyle={{textAlign: "center", width:100}}>
                {data.userName}
            </Ditems>
            <Ditems label="등록일" span={1} labelStyle={{textAlign: "center", width:100}}>
                {formatDate(data.createDate)}
            </Ditems>
            <Ditems label="문의내용" span={2} labelStyle={{textAlign: "center", width:150}}>
                {data.title}
            </Ditems>          
            <Ditems label="답변" span={2}  labelStyle={{textAlign: "center", width:150}}>
                <Input.TextArea
                rows={8}
                value={this.state.answer}
                placeholder="답변을 등록해주세요"
                onChange={(e) => {
                    this.setState({
                     answer: e.target.value
                    });
                }}
                style={{ width : "100%"}}
                />          
                
             
            </Ditems>     
            <Ditems label="답변일" span={2} labelStyle={{textAlign: "center", width:150}}>
                {data === null ? "-" : formatDate(data.updateDate)}
            </Ditems>          
        </Descriptions>
    </Modal>
);
}
}
export default InquiryDetailModal;